/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulworkshopstorytelling4Inputs */

const de__field_participatedulworkshopstorytelling4 = /** @type {(inputs: _Field_Participatedulworkshopstorytelling4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Workshop Storytelling`)
};

/**

* @param {_Field_Participatedulworkshopstorytelling4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulworkshopstorytelling4 = /** @type {((inputs?: _Field_Participatedulworkshopstorytelling4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulworkshopstorytelling4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulworkshopstorytelling4(inputs)
});
export { _field_participatedulworkshopstorytelling4 as "_field_participatedULWorkshopStorytelling" }